import axios from "../../../../configs/axiosIntereptor";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getUserActivity = () => {
  return axios.get(`${BASE_URL}/api/billing/connected-users-connection-info`);
};

export const getResellerAccActivity = () => {
  return axios.get(`${BASE_URL}/api/billing/connected-users-count`);
};
export const bookADemo = (payload) => {
  return axios.post(`${BASE_URL}/api/dashboard/book-a-demo`, payload);
};
export const getDashboardSummary = (token) => {
  return axios.get(`${BASE_URL}/api/dashboard/dashboard-summary`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};